import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import type { PublicBookingConfig } from "@/types";

export function useTouristIntegrationEnabled(): { enabled: boolean; loading: boolean } {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    void api
      .get<PublicBookingConfig>("/api/v1/public/booking/config")
      .then((cfg) => {
        if (!cancelled) setEnabled(cfg.tourist_integration_enabled === true);
      })
      .catch(() => {
        if (!cancelled) setEnabled(false);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { enabled, loading };
}
